import Echo from 'laravel-echo';

export default function () {
    window._ = require('lodash');
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    window.Pusher = require('pusher-js');
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: window.credManager.pusherApiKey(),
        cluster: window.credManager.pusherCluster(),
        forceTLS: window.forceTLS,
        disableStats: false,
    });
    window.Echo.connector.pusher.connection.bind('connecting', () => {
        console.log('connecting...');
    });
    window.Echo.connector.pusher.connection.bind('connected', (payload) => {
        console.log('connected!', payload);
    });
    window.Echo.connector.pusher.connection.bind('unavailable', (payload) => {
        console.log('unavailable', payload);
    });
    window.Echo.connector.pusher.connection.bind('failed', (payload) => {
        console.log('failed', payload);
        window.Echo.connect();
    });
    window.Echo.connector.pusher.connection.bind('disconnected', (payload) => {
        console.log('disconnected', payload);
        window.Echo.connect();
    });
}
